"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeQueryLimits = exports.withOffset = exports.getOffsetForToday = exports.isQueryLimits = exports.isThrottleSettings = exports.isQuotaSettings = void 0;
const lodash_1 = __importDefault(require("lodash"));
const date_fns_1 = require("date-fns");
const validation_1 = require("../validator/validation");
const MAX_WEEK_OFFSET = 6;
const MAX_MONTH_OFFSET = 27;
exports.isQuotaSettings = (0, validation_1.isAllOf)((0, validation_1.isPartialObjectOf)({
    limit: validation_1.isNaturalNumber,
}), (0, validation_1.isSomeOf)((0, validation_1.isPartialObjectOf)({
    period: (0, validation_1.isLiteral)('DAY'),
    offset: validation_1.isUndefined.or((0, validation_1.isLiteral)(0)),
}), (0, validation_1.isPartialObjectOf)({
    period: (0, validation_1.isLiteral)('WEEK'),
    offset: validation_1.isUndefined.or(validation_1.isNaturalNumber.which((0, validation_1.satisfiesCondition)(n => n <= MAX_WEEK_OFFSET))),
}), (0, validation_1.isPartialObjectOf)({
    period: (0, validation_1.isLiteral)('MONTH'),
    offset: validation_1.isUndefined.or(validation_1.isNaturalNumber.which((0, validation_1.satisfiesCondition)(n => n <= MAX_MONTH_OFFSET))),
})));
exports.isThrottleSettings = (0, validation_1.isPartialObjectOf)({
    burstLimit: validation_1.isNaturalNumber,
    rateLimit: validation_1.isNaturalNumber,
});
exports.isQueryLimits = (0, validation_1.isPartialObjectOf)({
    quota: validation_1.isUndefined.or(exports.isQuotaSettings),
    throttle: validation_1.isUndefined.or(exports.isThrottleSettings),
});
function getOffsetForToday(period, today = new Date()) {
    if (period === 'DAY')
        return 0;
    else if (period === 'WEEK') {
        return Math.max(0, Math.min(MAX_WEEK_OFFSET, (0, date_fns_1.getDay)(today)));
    }
    else {
        const zeroIndexDayOfMonth = (0, date_fns_1.getDate)(today) - 1;
        return Math.max(0, Math.min(MAX_MONTH_OFFSET, zeroIndexDayOfMonth));
    }
}
exports.getOffsetForToday = getOffsetForToday;
function withOffset(limits, today = new Date()) {
    var _a, _b, _c;
    const noOffset = lodash_1.default.isNil((_a = limits.quota) === null || _a === void 0 ? void 0 : _a.offset);
    const defaultOffset = ((_b = limits.quota) === null || _b === void 0 ? void 0 : _b.offset) === 0;
    const period = ((_c = limits.quota) === null || _c === void 0 ? void 0 : _c.period) || 'MONTH';
    const limitDefaults = {
        quota: {
            offset: getOffsetForToday(period, today),
            period,
        },
    };
    if (noOffset || defaultOffset || (0, exports.isQueryLimits)(limits)) {
        return exports.isQueryLimits.validate(mergeQueryLimits(limits, limitDefaults));
    }
    return limits;
}
exports.withOffset = withOffset;
function mergeQueryLimits(...ql) {
    const limits = ql === null || ql === void 0 ? void 0 : ql.filter(l => !lodash_1.default.isNil(l));
    if (!limits || lodash_1.default.isEmpty(limits)) {
        return null;
    }
    limits.forEach(limit => exports.isQueryLimits.validate(limit));
    if (lodash_1.default.size(limits) === 1) {
        return limits.find(() => true);
    }
    return lodash_1.default.tail(limits).reduce((prev, current) => {
        const mergedQuota = { ...((prev === null || prev === void 0 ? void 0 : prev.quota) || {}), ...((current === null || current === void 0 ? void 0 : current.quota) || {}) };
        const mergedThrottle = {
            ...((prev === null || prev === void 0 ? void 0 : prev.throttle) || {}),
            ...((current === null || current === void 0 ? void 0 : current.throttle) || {}),
        };
        return {
            quota: lodash_1.default.isEmpty(mergedQuota) ? undefined : mergedQuota,
            throttle: lodash_1.default.isEmpty(mergedThrottle) ? undefined : mergedThrottle,
        };
    }, lodash_1.default.head(limits));
}
exports.mergeQueryLimits = mergeQueryLimits;
//# sourceMappingURL=QueryLimits.js.map